import { typeOfObject } from "./typeOfObject";

export function jsonToQueryString(data: { [name: string]: any }): string {
    if (typeOfObject(data) !== "Object") {
        throw new Error("jsonToQueryString: data must be an object");
    }

    return Object.keys(data)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
}